import { ReferenceField, ThemeModeToggle } from "@/components/admin"
import { Badge } from "@/components/ui/badge"
import { Button } from "@/components/ui/button"
import { Card, CardContent } from "@/components/ui/card"
import { Label } from "@/components/ui/label"
import { Separator } from "@/components/ui/separator"
import { TabsContent, TabsTrigger } from "@/components/ui/tabs"

export const AccountTab = () => {
  return (
    <TabsContent value="account">
      <Card>
        <CardContent className="space-y-6">
          <div className="flex items-center justify-between">
            <div className="space-y-1">
              <Label className="text-base">Thème du compte</Label>
              <p className="text-muted-foreground text-sm">
                Choisissez entre les modes Clair ou Sombre
              </p>
            </div>
            <ThemeModeToggle />
          </div>

          <ReferenceField
            source="id"
            reference="contracts"
            render={({ error, isPending, referenceRecord }) => {
              if (isPending) {
                return <p>Chargement...</p>
              }
              if (error) {
                return <p className="error">{error.message}</p>
              }
              return (
                <div className="space-y-6">
                  <div className="flex items-center justify-between">
                    <div className="space-y-1">
                      <Label className="text-base">Type de compte</Label>
                      <p className="text-muted-foreground text-sm">
                        Rôle de l'utilisateur dans l'application
                      </p>
                    </div>
                    {referenceRecord?.user_role ? (
                      <Badge
                        variant="outline"
                        className="border-green-200 bg-green-50 text-green-700 rounded-full"
                      >
                        {referenceRecord?.user_role}
                      </Badge>
                    ) : (
                      <Badge className="bg-destructive/10 [a&]:hover:bg-destructive/5 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 text-destructive rounded-full border-none focus-visible:outline-none">
                        <span
                          className="bg-destructive size-1.5 rounded-full"
                          aria-hidden="true"
                        />
                        informations manquantes
                      </Badge>
                    )}
                  </div>
                  <div className="flex items-center justify-between">
                    <div className="space-y-1">
                      <Label className="text-base">Nom d'utilisateur</Label>
                      <p className="text-muted-foreground text-sm">
                        Utilisé comme référence dans le chat et les mentions
                      </p>
                    </div>
                    {referenceRecord?.username ? (
                      <Badge
                        variant="outline"
                        className="border-green-200 bg-green-50 text-green-700 rounded-full"
                      >
                        {referenceRecord?.username}
                      </Badge>
                    ) : (
                      <Badge className="bg-destructive/10 [a&]:hover:bg-destructive/5 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 text-destructive rounded-full border-none focus-visible:outline-none">
                        <span
                          className="bg-destructive size-1.5 rounded-full"
                          aria-hidden="true"
                        />
                        informations manquantes
                      </Badge>
                    )}
                  </div>
                </div>
              )
            }}
          />

          <Separator />
          <div className="flex items-center justify-between">
            <div className="space-y-1">
              <Label className="text-base">Plan d'abonnement</Label>
              <p className="text-muted-foreground text-sm">
                Plan Pro - 29€/mois
              </p>
            </div>
            <Button disabled variant="outline">
              Gérer l'abonnement
            </Button>
          </div>
        </CardContent>
      </Card>
    </TabsContent>
  )
}
export const AccountTrigger = () => (
  <TabsTrigger
    value="account"
    className="rounded-fullcursor-pointer flex flex-col items-center gap-1 data-[state=active]:bg-primary dark:data-[state=active]:bg-primary data-[state=active]:text-primary-foreground dark:data-[state=active]:text-primary-foreground dark:data-[state=active]:border-transparent"
  >
    Compte
  </TabsTrigger>
)
